import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {
  HeightType,
  SimpleModalComponent,
  WidthType
} from '@com-delta-idp/mnx-ui-kit';
@Component({
  selector: 'idp-view-modal',
  templateUrl: './view-modal.component.html',
  styleUrls: ['./view-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ViewModalComponent {
  @Input() modalTitle = '';
  @Input() modalOpen = false;
  @Input() submitBtnTitle = '';
  @Input() showFooter = true;
  @Input() buttonStyle = 'secondary';
  @Input() showCloseBtn = false;
  @Input() cancelBtnTitle = '';
  @Input() showContinueBtn = false;
  @Input() showSubmitBtn = false;
  @Input() alertMsg = false;
  @Input() closePopupModal = this.modalOpen;
  @Input() content = {};
  @Input() sideTopPaddingEnabled = true;
  @Input() width: WidthType = 'auto';
  @Input() height: HeightType = 'auto';
  @Input() showCloseIcon = true;
  @Input() headerStyle = 'dark';
  @Input() whiteCloseIcon = true;
  @Output() modalDone = new EventEmitter<Event>();
  @Output() modalSave = new EventEmitter<Event>();
  @Output() modalCancel = new EventEmitter<Event>();
  @Output() previousTab = new EventEmitter<Event>();
  @ViewChild(SimpleModalComponent) modal!: SimpleModalComponent;

  get modalBodyElement(): HTMLElement {
    return this.modal.simpleModalRef.nativeElement;
  }

  closeModal() {
    this.modalDone.emit();
  }

  onSaveModal(): void {
    this.modalSave.emit();
  }

  onCancel(): void {
    this.modalCancel.emit();
  }

  onPreviousTab(event: Event): void {
    this.previousTab.emit(event);
  }
}
